(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
      this.panels = Array.from(this.querySelectorAll('[data-pairs-for]'));
      try {
        this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }
      this.lookup = new Map(this.variants.map((v) => [v.s + '|||' + v.c, v]));

      try {
        const giftEl = this.querySelector('[data-gift-variants]');
        this.giftVariants = giftEl ? JSON.parse(giftEl.textContent) : [];
      } catch (e) {
        this.giftVariants = [];
      }
      this.giftLookup = new Map(this.giftVariants.map((v) => [v.s + '|||' + v.c, v]));

      this.radios.forEach((r) => r.addEventListener('change', () => this.update()));
      this.initPairDefaults();
      this.update();
      this.hookSubmit();
    }

    productForm() {
      const section = this.closest('.shopify-section') || document;
      return section.querySelector('form[action*="/cart/add"]');
    }

    currentVariant() {
      const form = this.productForm();
      const idInput = form && form.querySelector('[name="id"]');
      if (!idInput) return null;
      return this.variants.find((v) => String(v.id) === String(idInput.value)) || null;
    }

    initPairDefaults() {
      const cur = this.currentVariant() || this.variants[0];
      if (cur) {
        this.panels.forEach((panel) => {
          panel.querySelectorAll('[data-pair-size]').forEach((s) => (s.value = cur.s));
          panel.querySelectorAll('[data-pair-color]').forEach((c) => (c.value = cur.c));
        });
      }
      if (this.giftVariants && this.giftVariants.length) {
        const g = this.giftVariants.find((v) => v.a) || this.giftVariants[0];
        this.querySelectorAll('[data-gift-size]').forEach((s) => (s.value = g.s));
        this.querySelectorAll('[data-gift-color]').forEach((c) => (c.value = g.c));
      }
    }

    checkedRadio() {
      return this.radios.find((r) => r.checked);
    }

    update() {
      const checked = this.checkedRadio();
      const tier = checked ? checked.dataset.tier : null;
      const qty = checked ? parseInt(checked.value, 10) : 1;
      this.panels.forEach((p) => (p.hidden = p.dataset.pairsFor !== tier));

      // native form altijd op quantity 1 — bundels gaan via /cart/add.js
      const form = this.productForm();
      if (!form) return;
      let input = form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
      }
      if (input.value !== '1') {
        input.value = '1';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.bundleQty = qty;
    }

    bundleItems() {
      const checked = this.checkedRadio();
      if (!checked) return null;
      const panel = this.panels.find((p) => p.dataset.pairsFor === checked.dataset.tier);
      if (!panel) return null; // 1 pair: native flow
      const items = [];
      const pairs = panel.querySelectorAll('.bundle-selector__pair');
      for (const pair of pairs) {
        const s = pair.querySelector('[data-pair-size]').value;
        const c = pair.querySelector('[data-pair-color]').value;
        const variant = this.lookup.get(s + '|||' + c);
        if (!variant || !variant.a) return { error: s + ' / ' + c };
        items.push({ id: variant.id, quantity: 1 });
      }
      const giftSize = panel.querySelector('[data-gift-size]');
      const giftColor = panel.querySelector('[data-gift-color]');
      if (giftSize && giftColor && this.giftLookup) {
        const gv = this.giftLookup.get(giftSize.value + '|||' + giftColor.value);
        // Insert at index 1 so the gift is added first (oldest) and lands at the
        // bottom of the cart (Horizon shows newest-added at the top).
        if (gv) items.splice(1, 0, { id: gv.id, quantity: 1 });
      }
      return { items };
    }

    hookSubmit() {
      const form = this.productForm();
      if (!form) return;
      const section = this.closest('.shopify-section') || document;

      // Onderschept klik óf submit; voegt de extra paren toe via /cart/add.js
      // en speelt daarna de oorspronkelijke actie opnieuw af voor het laatste
      // paar, zodat Horizon zelf de cart-drawer opent.
      const intercept = (e, replay) => {
        if (this._passthrough) return;
        const bundle = this.bundleItems();
        if (!bundle) return; // 1 pair: native flow
        e.preventDefault();
        e.stopImmediatePropagation();
        if (bundle.error) {
          alert('This combination is unavailable: ' + bundle.error);
          return;
        }
        const [first, ...rest] = bundle.items;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: rest }),
        })
          .then((r) => {
            if (!r.ok) throw new Error('cart add failed');
            const idInput = form.querySelector('[name="id"]');
            if (idInput) idInput.value = first.id;
            this._passthrough = true;
            replay();
            setTimeout(() => {
              this._passthrough = false;
            }, 0);
          })
          .catch(() => alert('Something went wrong adding the bundle. Please try again.'));
      };

      section.addEventListener(
        'click',
        (e) => {
          const btn = e.target && e.target.closest
            ? e.target.closest('button[type="submit"], button[name="add"]')
            : null;
          if (!btn || !form.contains(btn)) return;
          intercept(e, () => btn.click());
        },
        true
      );

      form.addEventListener(
        'submit',
        (e) => {
          intercept(e, () => form.requestSubmit());
        },
        true
      );
    }
  }

  if (!customElements.get('bundle-selector')) {
    customElements.define('bundle-selector', BundleSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mini-review"] && !Shopify.designMode) return;
  try {
    class MiniReview extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.mini-review__slide'));
      this.index = 0;
      const next = this.querySelector('.mini-review__next');
      if (next) {
        next.addEventListener('click', () => {
          this.index = (this.index + 1) % this.slides.length;
          this.slides.forEach((s, i) => {
            s.hidden = i !== this.index;
            s.classList.toggle('is-entering', i === this.index);
          });
        });
      }
    }
  }

  if (!customElements.get('mini-review')) {
    customElements.define('mini-review', MiniReview);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["offer-countdown"] && !Shopify.designMode) return;
  try {
    class OfferCountdown extends HTMLElement {
    connectedCallback() {
      const raw = (this.dataset.end || '').trim().replace(' ', 'T');
      this.end = new Date(raw);
      if (isNaN(this.end.getTime())) return;
      this.values = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const ms = this.end.getTime() - Date.now();
      if (ms <= 0) {
        this.hidden = true;
        clearInterval(this.interval);
        return;
      }
      this.hidden = false;
      const s = Math.floor(ms / 1000);
      this.values.days.textContent = Math.floor(s / 86400);
      this.values.hours.textContent = String(Math.floor((s % 86400) / 3600)).padStart(2, '0');
      this.values.minutes.textContent = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      this.values.seconds.textContent = String(s % 60).padStart(2, '0');
    }
  }

  if (!customElements.get('offer-countdown')) {
    customElements.define('offer-countdown', OfferCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
